import { getResourceSlugId } from "@pathwright/features/src/modules/utils/urls"

const LIBRARY_SLUG_RE = /^\/library\/([^/]+)/

type RouteResource = { id?: number | null; slug?: string | null }

export const isResourceRoute = (
  resource: RouteResource | null | undefined,
  pathname: string = window.location.pathname
) => {
  const segment = pathname.match(LIBRARY_SLUG_RE)?.[1]
  if (!resource || !segment) return false
  if (segment === resource.slug) return true
  return resource.id != null && getResourceSlugId(segment) === resource.id
}
